import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonCieModel } from 'src/app/model/common/cie';
import { GeneralDiagnosticViewModel } from 'src/app/model/general/diagnostic.view';
import { DIAGNOSTIC_CONSTANTS } from './diagnostic.constants';
import { GeneralConsultDiagnosticService } from './diagnostic.service';

@Component({
  selector: 'ms-general-consult-diagnostic-item',
  templateUrl: './diagnostic-item.component.html',
})
export class GeneralConsultDiagnosticItemComponent {
  readonly screen = DIAGNOSTIC_CONSTANTS;
  @Input() readonly = false;
  @Input() canRemove = false;
  @Input() idx = -1;
  @Input() turn = -1;
  @Input() diagnostic: GeneralDiagnosticViewModel = {};
  @Output() diagnosticChange: EventEmitter<GeneralDiagnosticViewModel> =
    new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();
  suggestions: CommonCieModel[] = [];

  constructor(protected service: GeneralConsultDiagnosticService) {}

  getSuggestions = (query: string) =>
    this.service
      .fillCieSuggestion(query)
      .subscribe((suggestions) => (this.suggestions = suggestions));

  onKeyUp = (isCode: boolean = true) => {
    this.diagnostic.cie = undefined;
    if (isCode) {
      this.diagnostic.code = this.diagnostic.cieHelp?.id;
    } else {
      this.diagnostic.description = this.diagnostic.cieHelp?.description;
    }
    this.verifyCie();
  };

  fillWithSuggestion = (suggestion: CommonCieModel) => {
    // this.diagnostic.cie = suggestion.id;
    this.diagnostic.code = suggestion.id;
    this.diagnostic.description = suggestion.description;
    this.handleChange();
  };

  handleChange = () => this.diagnosticChange.emit(this.diagnostic);

  private verifyCie = () => {
    if (typeof this.diagnostic.cieHelp === 'string') {
      this.diagnostic.code = this.diagnostic.cieHelp as string;
      this.diagnostic.description = this.diagnostic.cieHelp as string;
    }
  };

  get description() {
    if (
      this.diagnostic.description &&
      this.diagnostic.description != this.diagnostic.displayName
    ) {
      return this.diagnostic.description;
    } else if (
      this.diagnostic.cieHelp &&
      this.diagnostic.cieHelp.description &&
      this.diagnostic.cieHelp.description != this.diagnostic.cieHelp.displayName
    ) {
      return this.diagnostic.cieHelp.description;
    }
    return null;
  }
}
